import React, { useState, useEffect, useContext } from 'react';
import { TreeSelect } from 'antd';
import Axios from 'axios';

import * as COM from '.';
import { AuthContext } from '../../containers/App';

export const DatasetTreeSelect = (props) => {
    const [value, setValue] = useState(null);
    const [treeData, setTreeData] = useState([]);
    const auth = useContext(AuthContext);

    const listToTreeByParentId = (list) => {
        var map = {}, node, roots = [], i;

        for (i = 0; i < list.length; i += 1) {
            map[list[i].id] = i;
            list[i].children = [];
        }

        for (i = 0; i < list.length; i += 1) {
            node = list[i];
            if (node.parentId !== null) {
                list[map[node.parentId]].children.push(node);
            } else {
                roots.push(node);
            }
        }
        return roots;
    }

    const fetchData = async () => {
        try {
            let data = await COM.fetchData({
                connector: props.connector,
                dataset: props.dataset,
                filters: props.filters ? props.filters : {}
            }, auth);
            setTreeData(listToTreeByParentId(data));
            return data;
        } catch (err) {
            console.log(err);
        }
    };

    const fetchAll = async () => {
        await fetchData();
    }

    useEffect(() => {
        fetchAll();
    }, []);

    const onChange = value => {
        setValue(value);
    };

    return (
        <TreeSelect
            treeDataSimpleMode
            style={{ width: '100%' }}
            value={value}
            onChange={onChange}
            treeData={treeData}
            {...props}
        />
    );
};